var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinPinFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 79,
    viewBox: "0 0 65 79",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7407 0.0559377L0.711426 76.591C10.6002 77.5397 21.4799 78.1368 33.2194 78.1199C44.5904 78.1029 55.1482 77.51 64.7744 76.591C54.098 51.0793 43.4214 25.5676 32.745 0.0559377L32.7407 0.0559377Z",
    fill: "url(#paint0_radial_3916_52484)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7407 73.5921C24.2834 73.5921 15.7457 73.2618 7.28416 72.6138L32.745 11.7822L44.586 40.072L58.2059 72.6138C49.8968 73.2533 41.5157 73.5837 33.2151 73.5921L32.745 73.5921M32.745 78.1193C32.9017 78.1193 33.0627 78.1193 33.2194 78.1193C44.5904 78.1024 55.1482 77.5095 64.7744 76.5905C54.098 51.0788 43.4214 25.5671 32.745 0.0554189L0.715652 76.5905C10.4689 77.5264 21.1919 78.1236 32.745 78.1236L32.745 78.1193Z",
    fill: "url(#paint1_radial_3916_52484)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3916_52484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.6606 44.4769) rotate(180) scale(146.65 146.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF8200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF7200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3916_52484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7408 39.0895) rotate(180) scale(35.7054 35.7054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFA34F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF9D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FF9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFA84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFCF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFCF4F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinPinFree);
export default __webpack_public_path__ + "static/media/spin-pin-free.bd44e87844959cb2c8a1b89b297e6595.svg";
export { ForwardRef as ReactComponent };